/* assets/1-enrollment-form.js */
(() => {
  'use strict';

  const MAX_CHILDREN = 6;
  const MAX_ACTIVITIES = 10;
  const STORAGE_KEY = 'selectedActivities';

  const modal = document.querySelector('[data-enrollment-modal]');
  const overlay = document.querySelector('[data-enrollment-overlay]');
  const form = document.querySelector('[data-enrollment-form]');
  if (!modal || !form) return;

  const enrollmentCatalog = window.enrollmentCatalog || {};

  const errorEl = form.querySelector('[data-enrollment-error]');
  const reviewEl = form.querySelector('[data-review]');
  const childrenWrap = form.querySelector('[data-children]');
  const addChildBtn = form.querySelector('[data-add-child]');
  const limitNoteEl = form.querySelector('[data-children-limit-note]');
  const kidsSubtitle = modal.querySelector('[data-children-count]');
  const backBtn = form.querySelector('[data-step-back]');
  const ctaBtn = form.querySelector('[data-step-cta]');

  let step = 1;
  let isSubmitting = false;
  let modalFlow = 'enrollment'; // 'enrollment', 'enrollment-online', 'activities-form'
  let onlineProductData = null; // Stores the fetched online product JSON
  let payMethod = form.querySelector('input[name="pay_method"]:checked')?.value || 'online';
  let desiredKids = 1;
  let openerTaxVariantId = 0;
  let plan = '';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const setError = (msg = '') => {
    if (!errorEl) return;
    errorEl.hidden = !msg;
    errorEl.textContent = msg;
  };

  const sanitizeText = (value, maxLen = 200) => {
    const str = String(value ?? '').replace(/[\u0000-\u001F\u007F]/g, ' ').trim();
    return str.length > maxLen ? str.slice(0, maxLen) : str;
  };

  const normalizeEmail = (email) => sanitizeText(email, 254).toLowerCase();

  const normalizePhone = (phone) => {
    const raw = sanitizeText(phone, 32);
    return raw.replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
  };

  const isValidEmail = (emailRaw) => {
    const email = normalizeEmail(emailRaw);
    if (!email) return false;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return false;
    return !email.endsWith('@abv.bg');
  };

  const isValidPhone = (phoneRaw) => /^\+?\d{7,15}$/.test(normalizePhone(phoneRaw));

  const hasLatinLetters = (str) => /[a-zA-Z]/.test(String(str || ''));

  const escapeHtml = (str) => String(str)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const getChildBlocks = () => childrenWrap ? $$('[data-child]', childrenWrap) : [];

  const getSchoolEntry = (schoolKey) => enrollmentCatalog[String(schoolKey || '').trim()] || null;
  const getGradeEntry = (schoolKey, gradeKey) =>
    getSchoolEntry(schoolKey)?.grades?.[String(gradeKey || '').trim()] || null;

  const resetSelect = (select, placeholder, disabled = true) => {
    if (!select) return;
    select.innerHTML = `<option value="">${placeholder}</option>`;
    select.disabled = disabled;
  };

  // --- UI Population Helpers ---
  const populateSchoolSelect = (block) => {
    const schoolSelect = $('[data-school]', block);
    if (!schoolSelect) return;

    if (modalFlow === 'enrollment-online') {
      // Lock to Online Mode
      resetSelect(schoolSelect, 'Онлайн обучение', false);
      const option = document.createElement('option');
      option.value = 'online';
      option.textContent = 'Онлайн обучение';
      option.selected = true;
      schoolSelect.appendChild(option);
      schoolSelect.disabled = true; // Prevent changing
    } else {
      // Normal Attendance Mode
      const currentValue = schoolSelect.value;
      resetSelect(schoolSelect, 'Изберете...', false);

      Object.entries(enrollmentCatalog).forEach(([key, school]) => {
        const option = document.createElement('option');
        option.value = key;
        option.textContent = school.label || key;
        if (key === currentValue) option.selected = true;
        schoolSelect.appendChild(option);
      });
    }
  };

  const populateGradeSelect = (block, preserveValue = '') => {
    const gradeSelect = $('[data-grade]', block);
    if (!gradeSelect) return;

    if (modalFlow === 'enrollment-online') {
      resetSelect(gradeSelect, 'Изберете клас...', false);
      if (!onlineProductData?.variants) return;

      onlineProductData.variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = variant.id;
        
        if (!variant.available) {
          option.textContent = `${variant.title} (няма свободни места)`;
          option.dataset.soldOut = 'true';
        } else {
          option.textContent = variant.title;
        }
        
        if (String(variant.id) === String(preserveValue)) option.selected = true;
        gradeSelect.appendChild(option);
      });
    } else {
      const schoolSelect = $('[data-school]', block);
      if (!schoolSelect) return;

      const school = getSchoolEntry(schoolSelect.value);
      resetSelect(gradeSelect, 'Изберете...', !school);

      if (!school?.grades) return;

      Object.entries(school.grades).forEach(([key, grade]) => {
        const option = document.createElement('option');
        option.value = key;
        const isAvailable = window.gradeInventory[grade.handle] !== false; 

        if (!isAvailable) {
          option.textContent = `${grade.label || key} (няма свободни места)`;
          option.dataset.soldOut = 'true';
        } else {
          option.textContent = grade.label || key;
        }
        
        if (key === preserveValue) option.selected = true;
        gradeSelect.appendChild(option);
      });
    }
  };

  const updateActivitiesVisibility = (block) => {
    const gradeSelect = $('[data-grade]', block);
    const activitiesFieldset = $('.only-full', block);
    
    if (!gradeSelect || !activitiesFieldset) return;

    const gradeKey = gradeSelect.value;
    let hide = false;

    if (modalFlow === 'enrollment-online') {
      hide = true;
    } else if (gradeKey) {
      const highGrades = [
        'grade_5', 'grade_6', 'grade_7', 'grade_8', 'grade_9', 
        'grade_10', 'grade_11', 'grade_12', 'grade_mix_9_10', 'grade_mix_11_12'
      ];
      hide = highGrades.includes(gradeKey);
    }

    if (hide) {
      activitiesFieldset.style.display = 'none';
      // Uncheck them so they don't get accidentally submitted
      $$('input[type="checkbox"]', activitiesFieldset).forEach(cb => { cb.checked = false; });
    } else {
      activitiesFieldset.style.display = ''; 
    }
  };

  const updateWaitlistUI = (block) => {
    const gradeSelect = $('[data-grade]', block);
    const fieldsWrap = $('[data-child-fields]', block);
    const waitlistWrap = $('[data-child-waitlist]', block);
    
    if (!gradeSelect || !fieldsWrap || !waitlistWrap) return;

    const selectedOption = gradeSelect.options[gradeSelect.selectedIndex];
    const isSoldOut = selectedOption && selectedOption.dataset.soldOut === 'true';

    if (isSoldOut) {
      fieldsWrap.style.display = 'none';
      waitlistWrap.hidden = false;
    } else {
      fieldsWrap.style.display = '';
      waitlistWrap.hidden = true;
    }
  };

  const hydrateChildBlock = (block) => {
    const currentGrade = $('[data-grade]', block)?.value || '';
    populateSchoolSelect(block);
    populateGradeSelect(block, currentGrade);
    updateActivitiesVisibility(block);
    updateWaitlistUI(block);
  };

  const hydrateAllChildren = () => {
    getChildBlocks().forEach(hydrateChildBlock);
  };

  const updateChildrenUI = () => {
    const count = getChildBlocks().length;

    if (kidsSubtitle) {
      kidsSubtitle.textContent = count === 1 ? 'Едно дете' : `${count} деца`;
    }

    if (addChildBtn) {
      addChildBtn.disabled = count >= MAX_CHILDREN;
    }

    if (limitNoteEl) {
      limitNoteEl.textContent =
        count >= MAX_CHILDREN ? `Достигнахте максимума от ${MAX_CHILDREN} деца.` : '';
    }

    getChildBlocks().forEach(block => {
      const removeBtn = $('[data-remove-child]', block);
      if (removeBtn) removeBtn.disabled = count <= 1;
    });
  };

  const resetChildBlock = (block) => {
    $$('input, textarea, select', block).forEach(el => {
      if (el.type === 'checkbox' || el.type === 'radio') {
        el.checked = false;
        return;
      }
      if (el.tagName === 'SELECT') {
        el.selectedIndex = 0;
        return;
      }
      el.value = '';
    });
    hydrateChildBlock(block);
  };

  const cloneChildFromFirst = () => {
    const first = childrenWrap?.querySelector('[data-child]');
    if (!first) return null;

    const clone = first.cloneNode(true);
    resetChildBlock(clone);
    return clone;
  };

  const setChildrenCount = (count) => {
    if (!childrenWrap) return;

    const desired = Math.max(1, Math.min(MAX_CHILDREN, Number(count || 1)));
    let blocks = getChildBlocks();

    while (blocks.length < desired) {
      const clone = cloneChildFromFirst();
      if (!clone) break;
      childrenWrap.appendChild(clone);
      blocks = getChildBlocks();
    }

    while (blocks.length > desired) {
      blocks[blocks.length - 1].remove();
      blocks = getChildBlocks();
    }

    hydrateAllChildren();
    updateChildrenUI();
  };

  const getParentAttributes = () => ({
    'Родител/Настойник (име)': sanitizeText($('[data-parent-name]', form)?.value || '', 120),
    'Адрес': sanitizeText($('[data-parent-address]', form)?.value || '', 200),
    'Email': normalizeEmail($('[data-parent-email]', form)?.value || ''),
    'Телефон': normalizePhone($('[data-parent-phone]', form)?.value || ''),
    'Контакт при спешни случаи': sanitizeText($('[data-emergency-contact]', form)?.value || '', 120),
    'Други деца в училището': sanitizeText($('[data-other-children]', form)?.value || '', 120),
    'Съгласие: Правилник и ЗБУТ': $('[data-agree-rules]', form)?.checked ? 'Да' : 'Не',
    'Съгласие: Отписване': $('[data-agree-dropout]', form)?.checked ? 'Да' : 'Не',
    'Съгласие: Условия': $('[data-agree-terms]', form)?.checked ? 'Да' : 'Не'
  });

  const getEnrollmentType = () =>
    form.querySelector('input[name="class_visual"]:checked')?.value || '';

  const readSelectedActivitiesFromStorage = () => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY) || '[]';
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  };

  const writeSelectedActivitiesToStorage = (items) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (_) {}
  };

  // Helper to clear activities
  const clearSelectedActivities = () => {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  };

  const upsertActivityHandle = (handle, title, checked) => {
    const cleanHandle = String(handle || '').trim();
    if (!cleanHandle || !/^[a-z0-9\-]+$/.test(cleanHandle)) return;

    const current = readSelectedActivitiesFromStorage()
      .filter(item => item && typeof item === 'object')
      .filter(item => {
        const itemHandle = String(item.handle || '').trim();
        return itemHandle && /^[a-z0-9\-]+$/.test(itemHandle);
      });

    const next = current.filter(item => String(item.handle).trim() !== cleanHandle);

    if (checked) {
      next.push({
        handle: cleanHandle,
        title: sanitizeText(title || cleanHandle, 120)
      });
    }

    writeSelectedActivitiesToStorage(next.slice(0, MAX_ACTIVITIES));
  };

  const fetchProductByHandle = async (handle) => {
    const cleanHandle = String(handle || '').trim();
    if (!cleanHandle) throw new Error('Липсва продуктов handle.');

    const response = await fetch(`/products/${cleanHandle}.js`, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(`Неуспешно зареждане на продукт: ${cleanHandle}`);
    }

    return response.json();
  };

  const hydrateActivitiesTitles = async () => {
    const items = readSelectedActivitiesFromStorage()
      .slice(0, MAX_ACTIVITIES)
      .filter(item => item && typeof item.handle === 'string' && /^[a-z0-9\-]+$/.test(item.handle));

    if (!items.length) return;

    const hydrated = [];

    for (const item of items) {
      try {
        const product = await fetchProductByHandle(item.handle);
        hydrated.push({
          handle: item.handle,
          title: sanitizeText(product.title || item.handle, 120)
        });
      } catch (_) {
        hydrated.push({
          handle: item.handle,
          title: sanitizeText(item.title || item.handle, 120)
        });
      }
    }

    writeSelectedActivitiesToStorage(hydrated);
  };

  const collectActivityRequests = () => {
    const items = readSelectedActivitiesFromStorage()
      .slice(0, MAX_ACTIVITIES)
      .filter(item => item && typeof item === 'object')
      .filter(item => typeof item.handle === 'string' && /^[a-z0-9\-]+$/.test(item.handle));

    const merged = new Map();
    const childCount = getChildBlocks().length; 

    items.forEach(item => {
      const key = item.handle;
      const existing = merged.get(key);

      if (existing) {
        existing.quantity += childCount;
      } else {
        merged.set(key, {
          handle: key,
          title: sanitizeText(item.title || key, 120),
          quantity: childCount
        });
      }
    });

    return Array.from(merged.values());
  };

  const validateEnrollment = () => {
    const attrs = getParentAttributes();

    if (!attrs['Родител/Настойник (име)']) return 'Моля, попълнете име на родител/настойник.';
    if (hasLatinLetters(attrs['Родител/Настойник (име)'])) return 'Моля, използвайте кирилица за име на родител/настойник.';

    if (!attrs['Адрес']) return 'Моля, попълнете адрес.';

    if (!attrs['Email']) return 'Моля, попълнете email.';
    if (!isValidEmail(attrs['Email'])) {
      return attrs['Email'].endsWith('@abv.bg')
        ? 'Моля, използвайте email различен от @abv.bg.'
        : 'Моля, въведете валиден email.';
    }

    if (!attrs['Телефон']) return 'Моля, попълнете телефон.';
    if (!isValidPhone(attrs['Телефон'])) return 'Моля, въведете валиден телефон.';

    if (attrs['Съгласие: Правилник и ЗБУТ'] !== 'Да') {
      return 'Моля, потвърдете правилника и политиката за здраве и безопасност.';
    }

    if (attrs['Съгласие: Отписване'] !== 'Да') {
      return 'Моля, потвърдете условията за отписване.';
    }

    if (attrs['Съгласие: Условия'] !== 'Да') {
      return 'Моля, приемете условията.';
    }

    const blocks = getChildBlocks();
    if (!blocks.length) return 'Моля, добавете поне едно дете.';
    if (blocks.length > MAX_CHILDREN) return `Максимум ${MAX_CHILDREN} деца.`;

    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      const gradeSelect = $('[data-grade]', block);
      const isSoldOut = gradeSelect && gradeSelect.options[gradeSelect.selectedIndex]?.dataset.soldOut === 'true';
      
      if (isSoldOut) {
        return `Класът избран за Дете ${i + 1} няма свободни места. За да продължите със записването, моля, премахнете това дете от формата или променете класа. (Записването в списък с чакащи става чрез бутона под класа).`;
      }

      const name = sanitizeText($('[data-child-fullname]', block)?.value || '', 120);
      const dob = sanitizeText($('[data-child-dob]', block)?.value || '', 40);
      const birthplace = sanitizeText($('[data-child-birthplace]', block)?.value || '', 120);
      const photo = sanitizeText($('[data-child-photo]', block)?.value || '', 40);

      if (!name || !dob || !birthplace) {
        return `Моля, попълнете име/дата/място на раждане за Дете ${i + 1}.`;
      }

      if (hasLatinLetters(name) || hasLatinLetters(birthplace)) {
        return `Моля, използвайте кирилица за име и място на раждане за Дете ${i + 1}.`;
      }

      if (!photo) {
        return `Моля, изберете разрешение за снимки за Дете ${i + 1}.`;
      }

      if (modalFlow === 'enrollment' || modalFlow === 'enrollment-online') {
        const gradeKey = sanitizeText($('[data-grade]', block)?.value || '', 80);
        
        if (!gradeKey) {
          return `Моля, изберете Клас за Дете ${i + 1}.`;
        }

        if (modalFlow === 'enrollment') {
          const schoolKey = sanitizeText($('[data-school]', block)?.value || '', 80);
          if (!schoolKey) return `Моля, изберете Училище за Дете ${i + 1}.`;
          
          const gradeEntry = getGradeEntry(schoolKey, gradeKey);
          if (!gradeEntry?.variant_id) {
            return `Комбинацията училище/клас не съществува (Дете ${i + 1}).`;
          }
        }
      }
    }

    if (modalFlow === 'activities-form') {
      const activities = collectActivityRequests();
      if (!activities.length) return 'Моля, изберете поне една дейност.';
    }

    return '';
  };

  const renderReview = () => {
    if (!reviewEl) return;

    const attrs = getParentAttributes();
    const blocks = getChildBlocks();

    let html = '';
    html += '<h4>Родител</h4>';
    html += `<p><strong>${escapeHtml(attrs['Родител/Настойник (име)'] || '')}</strong></p>`;
    html += `<p>${escapeHtml(attrs['Email'] || '')} • ${escapeHtml(attrs['Телефон'] || '')}</p>`;
    html += `<p>${escapeHtml(attrs['Адрес'] || '')}</p>`;
    html += '<hr/>';

    html += '<h4>Деца</h4>';
    blocks.forEach((block, index) => {
      const name = ($('[data-child-fullname]', block)?.value || '').trim();
      
      let schoolLabel = '';
      let gradeLabel = '';

      if (modalFlow === 'enrollment-online') {
        schoolLabel = 'Онлайн обучение';
        const gradeVal = $('[data-grade]', block)?.value;
        const variant = onlineProductData?.variants?.find(v => String(v.id) === String(gradeVal));
        gradeLabel = variant ? variant.title : gradeVal;
      } else {
        const school = getSchoolEntry($('[data-school]', block)?.value || '');
        const grade = getGradeEntry(
          $('[data-school]', block)?.value || '',
          $('[data-grade]', block)?.value || ''
        );
        schoolLabel = school?.label || '';
        gradeLabel = grade?.label || '';
      }

      if (modalFlow === 'activities-form') {
        html += `<p><strong>Дете ${index + 1}:</strong> ${escapeHtml(name)}</p>`;
      } else {
        html += `<p><strong>Дете ${index + 1}:</strong> ${escapeHtml(name)} — ${escapeHtml(schoolLabel)} / ${escapeHtml(gradeLabel)}</p>`;
      }
    });

    if (modalFlow === 'activities-form') {
      const activities = collectActivityRequests();
      if (activities.length) {
        html += '<hr/><h4>Допълнителни дейности</h4>';
        html += activities
          .map(item => `<p><strong>${escapeHtml(item.title)}</strong> — × ${item.quantity}</p>`)
          .join('');
      }
    } else {
      let hasAnyActivity = false;
      let actHtml = '<hr/><h4>Допълнителни дейности</h4>';
      
      blocks.forEach((block, index) => {
        const checked = Array.from(block.querySelectorAll('input[data-activity-handle]:checked'));
        if (checked.length) {
          hasAnyActivity = true;
          const actTitles = checked.map(cb => escapeHtml(cb.dataset.activityTitle || cb.dataset.activityHandle));
          actHtml += `<p><strong>Дете ${index + 1}:</strong> ${actTitles.join(', ')}</p>`;
        }
      });
      
      if (hasAnyActivity) {
        html += actHtml;
      }
    }

    reviewEl.innerHTML = html;
  };

  const resolveTaxCartItem = async () => {
    const id = Number(openerTaxVariantId || 0);
    if (!id) return null;

    return {
      id,
      quantity: 1,
      properties: {
        'Тип': 'Административна такса',
        'План': sanitizeText(plan, 40),
        'Брой деца': String(desiredKids)
      }
    };
  };

  const buildEnrollmentItems = () => {
    const enrollmentType = getEnrollmentType();

    return getChildBlocks().map(block => {
      const gradeKey = ($('[data-grade]', block)?.value || '').trim();
      let variantId = 0;
      let schoolLabel = '';
      let gradeLabel = '';

      if (modalFlow === 'enrollment-online') {
        variantId = Number(gradeKey);
        schoolLabel = 'Онлайн обучение';
        const variant = onlineProductData?.variants?.find(v => String(v.id) === String(variantId));
        gradeLabel = variant ? variant.title : gradeKey;
      } else {
        const schoolKey = ($('[data-school]', block)?.value || '').trim();
        const school = getSchoolEntry(schoolKey);
        const grade = getGradeEntry(schoolKey, gradeKey);
        variantId = Number(grade?.variant_id || 0);
        schoolLabel = school?.label || schoolKey;
        gradeLabel = grade?.label || gradeKey;
      }

      if (!variantId) return null;

      return {
        id: variantId,
        quantity: 1,
        properties: {
          '_Enrollment': 'Yes',
          'Тип записване': sanitizeText(enrollmentType, 40),
          'Училище': sanitizeText(schoolLabel, 80),
          'Клас/Група': sanitizeText(gradeLabel, 80),
          'Трите имена на детето': sanitizeText($('[data-child-fullname]', block)?.value || '', 120),
          'Дата на раждане': sanitizeText($('[data-child-dob]', block)?.value || '', 40),
          'Място на раждане': sanitizeText($('[data-child-birthplace]', block)?.value || '', 120),
          'Здравословна информация': sanitizeText($('[data-child-health]', block)?.value || '', 400),
          'Разрешение за снимки': sanitizeText($('[data-child-photo]', block)?.value || '', 40),
          'Допълнителна информация': sanitizeText($('[data-child-extra]', block)?.value || '', 400)
        }
      };
    }).filter(Boolean);
  };

  const resolveActivityCartItems = async () => {
    const items = [];
    const childBlocks = getChildBlocks();

    // 1. STANDALONE ACTIVITIES FLOW (Uses sessionStorage)
    if (modalFlow === 'activities-form') {
      const requests = collectActivityRequests();
      if (!requests.length) return [];

      for (const request of requests) {
        const product = await fetchProductByHandle(request.handle);
        const variant = (product.variants || []).find(item => item.available) || (product.variants || [])[0];

        if (!variant?.id) throw new Error(`Липсва вариант за дейност: ${sanitizeText(product.title || request.handle, 120)}`);

        for (let i = 0; i < childBlocks.length; i++) {
          const block = childBlocks[i];
          let schoolLabel = getSchoolEntry($('[data-school]', block)?.value || '')?.label || $('[data-school]', block)?.value || '';
          let gradeLabel = getGradeEntry($('[data-school]', block)?.value || '', $('[data-grade]', block)?.value || '')?.label || $('[data-grade]', block)?.value || '';

          items.push({
            id: variant.id,
            quantity: 1,
            properties: {
              'Тип': 'Допълнителна дейност',
              'Дейност': sanitizeText(product.title || request.title || request.handle, 120),
              'Дете №': String(i + 1),
              'Трите имена на детето': sanitizeText($('[data-child-fullname]', block)?.value || '', 120),
              'Дата на раждане': sanitizeText($('[data-child-dob]', block)?.value || '', 40),
              'Място на раждане': sanitizeText($('[data-child-birthplace]', block)?.value || '', 120),
              'Училище': sanitizeText(schoolLabel, 80),
              'Клас/Група': sanitizeText(gradeLabel, 80)
            }
          });
        }
      }
    } 
    // 2. REGULAR ENROLLMENT FLOW (Reads directly from each child's DOM)
    else {
      for (let i = 0; i < childBlocks.length; i++) {
        const block = childBlocks[i];
        // Find checked activities ONLY within this specific child's block
        const checkedActivities = Array.from(block.querySelectorAll('input[data-activity-handle]:checked'));
        
        if (!checkedActivities.length) continue;

        let schoolLabel = '';
        let gradeLabel = '';
        if (modalFlow === 'enrollment-online') {
          schoolLabel = 'Онлайн обучение';
          const gradeVal = $('[data-grade]', block)?.value;
          const v = onlineProductData?.variants?.find(v => String(v.id) === String(gradeVal));
          gradeLabel = v ? v.title : gradeVal;
        } else {
          schoolLabel = getSchoolEntry($('[data-school]', block)?.value || '')?.label || $('[data-school]', block)?.value || '';
          gradeLabel = getGradeEntry($('[data-school]', block)?.value || '', $('[data-grade]', block)?.value || '')?.label || $('[data-grade]', block)?.value || '';
        }

        for (const checkbox of checkedActivities) {
          const variantId = Number(checkbox.dataset.activityVariantId);
          const title = checkbox.dataset.activityTitle || checkbox.dataset.activityHandle;
          
          if (!variantId) continue;

          items.push({
            id: variantId,
            quantity: 1,
            properties: {
              'Тип': 'Допълнителна дейност',
              'Дейност': sanitizeText(title, 120),
              'Дете №': String(i + 1),
              'Трите имена на детето': sanitizeText($('[data-child-fullname]', block)?.value || '', 120),
              'Дата на раждане': sanitizeText($('[data-child-dob]', block)?.value || '', 40),
              'Място на раждане': sanitizeText($('[data-child-birthplace]', block)?.value || '', 120),
              'Училище': sanitizeText(schoolLabel, 80),
              'Клас/Група': sanitizeText(gradeLabel, 80)
            }
          });
        }
      }
    }

    return items;
  };

  const updateCartAttributes = async () => {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: getParentAttributes() })
    });

    if (!response.ok) {
      throw new Error('Грешка при запис на родителските данни.');
    }
  };

  const addItemsToCart = async (items) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      let message = 'Грешка при добавяне в количката.';
      try {
        const json = await response.json();
        message = json?.description || json?.message || message;
      } catch (_) {}
      throw new Error(message);
    }
  };

  const openCartUI = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      window.location.href = '/cart';
    }
  };

  const submitActivitiesForm = async () => {
    const activityItems = await resolveActivityCartItems();
    if (!activityItems.length) {
      throw new Error('Моля, изберете поне една дейност.');
    }
    await updateCartAttributes();
    await addItemsToCart(activityItems);
    
    // Clear storage BEFORE redirecting
    clearSelectedActivities();
    
    openCartUI();
    closeModal();
  };

  const submitEnrollment = async () => {
    const enrollmentItems = buildEnrollmentItems();
    if (!enrollmentItems.length) {
      throw new Error('Липсват валидни записвания за добавяне.');
    }

    const taxItem = await resolveTaxCartItem();
    const activityItems = await resolveActivityCartItems();

    const items = [
      ...enrollmentItems,
      ...(taxItem ? [taxItem] : []),
      ...activityItems
    ];

    await updateCartAttributes();
    await addItemsToCart(items);
    
    // Clear storage BEFORE redirecting
    clearSelectedActivities();
    
    openCartUI();
    closeModal();
  };

  const showStep = (nextStep) => {
    [1, 2, 3].forEach(n => {
      const stepEl = form.querySelector(`[data-step="${n}"]`);
      if (stepEl) stepEl.hidden = n !== nextStep;
    });

    step = nextStep;

    $$('[data-step-indicator]', modal).forEach(el => {
      const indicatorStep = Number(el.dataset.stepIndicator);
      el.classList.toggle('is-active', indicatorStep === step);
      el.classList.toggle('is-done', indicatorStep < step);
    });

    if (backBtn) backBtn.textContent = step === 1 ? 'Откажи' : 'Назад';

    if (ctaBtn) {
      if (step < 3) {
        ctaBtn.textContent = 'Напред';
      } else {
        ctaBtn.textContent = payMethod === 'online' ? 'Продължи към количка' : 'Изпрати заявление';
      }
    }

    setError('');
  };

  const openModal = async (triggerBtn) => {
    setError('');

    modal.hidden = false;
    if (overlay) overlay.hidden = false;
    modal.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    const handle = String(triggerBtn?.dataset?.enrollmentHandle || '').trim();

    if (handle) {
      modalFlow = 'enrollment-online';
      try {
        onlineProductData = await fetchProductByHandle(handle);
      } catch (e) {
        setError('Възникна грешка при зареждане на онлайн вариантите.');
      }
    } else {
      modalFlow = String(triggerBtn?.dataset?.flow || '').trim() === 'activities-form'
        ? 'activities-form'
        : 'enrollment';
      onlineProductData = null;
    }

    desiredKids = Math.max(1, Math.min(MAX_CHILDREN, Number(triggerBtn?.dataset?.kids || 1)));
    plan = String(triggerBtn?.dataset?.plan || '').trim();
    openerTaxVariantId = Number(triggerBtn?.dataset?.taxVariantId || 0);

    setChildrenCount(desiredKids);
    showStep(1);
  };

  // --- CLOSE MODAL ---
  const closeModal = () => {
    if (isSubmitting) return;

    modal.classList.remove('is-open');
    modal.hidden = true;
    if (overlay) overlay.hidden = true;

    document.body.classList.remove('overflow-hidden');
    setError('');

    // Wipe the Session Storage
    clearSelectedActivities();

    // Visually uncheck all checkboxes in the form
    $$('input[type="checkbox"]', form).forEach(cb => {
      cb.checked = false;
    });
  };

  // --- CYRILLIC ENFORCER ---
  let cyrillicWarningTimeout;

  document.addEventListener('input', (event) => {
    const target = event.target;

    if (!target.matches('input[type="text"], textarea')) return;

    const isExcluded = target.matches(`
      [data-parent-email], 
      [data-parent-phone], 
      [data-parent-address], 
      [data-child-dob], 
      input[type="email"], 
      input[type="password"], 
      input[type="tel"]
    `);
    
    if (isExcluded) return;

    if (/[a-zA-Z]/.test(target.value)) {
      target.value = target.value.replace(/[a-zA-Z]/g, '');
      setError('Моля, използвайте кирилица за това поле.');
      target.classList.add('is-invalid');
      clearTimeout(cyrillicWarningTimeout);

      cyrillicWarningTimeout = setTimeout(() => {
        target.classList.remove('is-invalid');
        if (errorEl && errorEl.textContent === 'Моля, използвайте кирилица за това поле.') {
          setError('');
        }
      }, 3000);
    } else {
      target.classList.remove('is-invalid');
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target;

    const activityEl = target instanceof HTMLElement ? target.closest('[data-activity-handle]') : null;
    if (activityEl instanceof HTMLElement) {
      if (target instanceof HTMLInputElement && target.type === 'checkbox') {
        // ONLY use sessionStorage if we are in the standalone activities flow
        if (modalFlow === 'activities-form') {
          const handle = String(activityEl.dataset.activityHandle || '').trim();
          const title = String(activityEl.dataset.activityTitle || '').trim();
          upsertActivityHandle(handle, title, target.checked);
        }
      }
      return;
    }

    if (!(target instanceof HTMLElement)) return;

    if (target.matches('input[name="pay_method"]')) {
      payMethod = target.value || 'online';
      showStep(step);
      return;
    }

    if (target.matches('[data-school]')) {
      const block = target.closest('[data-child]');
      if (modalFlow !== 'enrollment-online') {
        populateGradeSelect(block);
      }
    }

    if (target.matches('[data-grade]')) {
      const block = target.closest('[data-child]');
      if (block) {
        updateActivitiesVisibility(block);
        updateWaitlistUI(block); // ДОБАВЕНО: Обновяваме UI при смяна на класа
      }
      return;
    }
  });

  document.addEventListener('click', async (event) => {
    const openBtn = event.target.closest?.('[data-enrollment-open]');
    if (openBtn) {
      await openModal(openBtn);
      return;
    }

    const closeBtn = event.target.closest?.('[data-enrollment-close]');
    if (closeBtn) {
      closeModal();
      return;
    }

    if (overlay && event.target === overlay) {
      closeModal();
      return;
    }

    const addBtn = event.target.closest?.('[data-add-child]');
    if (addBtn && childrenWrap) {
      if (getChildBlocks().length >= MAX_CHILDREN) {
        updateChildrenUI();
        return;
      }
      const clone = cloneChildFromFirst();
      if (!clone) return;

      childrenWrap.appendChild(clone);
      hydrateAllChildren();
      updateChildrenUI();
      return;
    }

    const removeBtn = event.target.closest?.('[data-remove-child]');
    if (removeBtn && childrenWrap) {
      const block = removeBtn.closest('[data-child]');
      if (!block) return;
      if (getChildBlocks().length <= 1) {
        updateChildrenUI();
        return;
      }
      block.remove();
      updateChildrenUI();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  form.addEventListener('blur', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    if (target.matches('[data-parent-email]')) {
      target.classList.toggle('is-invalid', !isValidEmail(target.value));
    }

    if (target.matches('[data-parent-phone]')) {
      target.classList.toggle('is-invalid', !isValidPhone(target.value));
    }
  }, true);

  backBtn?.addEventListener('click', () => {
    if (step === 1) {
      closeModal();
      return;
    }
    showStep(step - 1);
  });

  ctaBtn?.addEventListener('click', async () => {
    setError('');

    if (step === 1) {
      const message = validateEnrollment();
      if (message) return setError(message);

      await hydrateActivitiesTitles();
      renderReview();
      return showStep(2);
    }

    if (step === 2) {
      return showStep(3);
    }

    const message = validateEnrollment();
    if (message) {
      setError(message);
      return showStep(1);
    }

    if (isSubmitting) return;

    isSubmitting = true;
    ctaBtn.disabled = true;
    if (backBtn) backBtn.disabled = true;

    try {
      if (modalFlow === 'activities-form') {
        await submitActivitiesForm();
      } else {
        await submitEnrollment();
      }
    } catch (error) {
      console.error(error);
      setError(error?.message || 'Възникна грешка. Моля опитайте отново.');
    } finally {
      isSubmitting = false;
      ctaBtn.disabled = false;
      if (backBtn) backBtn.disabled = false;
    }
  });

  showStep(1);
  hydrateAllChildren();
  updateChildrenUI();
})();